import React from 'react';

export const Header = () => {
  return <h2>Budget</h2>;
};
